// src/models/financeiro/FormaPag.js
export default class FormaPag {
  constructor(
    id = 0,
    descricao = "",
    //meioPag = MeioPagamento.Dinheiro, // Defina um valor padrão
    meioPag = MeioPagamento.Dinheiro,
    contaBancoId,
    avista,
    desconto,
    qtdeParcela,
    diaVencimento,
    juroMensal,
    juroAtrasoDia,
    caixaMov = false,
    caixaLocal = false,
    caixaResumoRel = false
  ) {
    this.id = id;
    this.descricao = descricao;
    this.meioPag = meioPag;
    this.contaBancoId = contaBancoId;
    this.avista = avista;
    this.desconto = desconto;
    this.qtdeParcela = qtdeParcela;
    this.diaVencimento = diaVencimento;
    this.juroMensal = juroMensal;
    this.juroAtrasoDia = juroAtrasoDia;
    this.caixaMov = caixaMov;
    this.caixaLocal = caixaLocal;
    this.caixaResumoRel = caixaResumoRel;
    this.usaTef = false;
    this.descontoDelivery = 0;
  }
}


// Enumeração para MeioPagamento, baseado no backend em C#
export const MeioPagamento = Object.freeze({  
  Dinheiro: 1,
  PIX: 17,
  CartaoCredito: 3,
  CartaoDebito: 4,
  Cheque: 5,
  Boleto: 15,
  Carne: 7,
  Fiado: 91,
  TEF_Manual: 99,
});

export const getDescricaoMeioPagamento = (value) => {
  switch (parseInt(value)) {    
    case 1:
      return 'Dinheiro';
    case 17:
      return 'PIX';
    case 3:
      return 'Cartão de Crédito';
    case 4:
      return 'Cartão de Débito';
    case 5:
      return 'Cheque';
    case 15:
      return 'Boleto';
    case 7:
      return 'Carnê';
    case 91:
      return 'Fiado';
    case 99:
      return 'TEF Manual';
    default:
      return 'Meio de pagamento desconhecido';
  }
};
